import { render, staticRenderFns } from "./CardCertified.vue?vue&type=template&id=eaa7e54a&scoped=true"
import script from "./CardCertified.vue?vue&type=script&lang=js"
export * from "./CardCertified.vue?vue&type=script&lang=js"
import style0 from "./CardCertified.vue?vue&type=style&index=0&id=eaa7e54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa7e54a",
  null
  
)

export default component.exports